import React from 'react';
import { useRef, useEffect } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

function IntlMessage({ type, onclick, ...props }) {
  const intl = useIntl();
  const detailRef = useRef(null);
  const keys = Object.entries(props).reduce((arr, [key, value]) => {
    arr[key] = { [key]: value };
    return arr;
  }, {});
  const message = intl.formatMessage(...Object.values(keys));

  useEffect(() => {
    if (!detailRef || !detailRef.current) return;
    if (onclick)
      detailRef.current.innerHTML = message.replace(
        '{onclick}',
        "id='intl-replace'",
      );
    else detailRef.current.innerHTML = message;
  }, [detailRef]);

  useEffect(() => {
    if (type !== 'HTML' || !onclick) return;
    if (document.getElementById('intl-replace'))
      document.getElementById('intl-replace').onclick = onclick;
  }, [document.getElementById('intl-replace')]);

  if (type === 'HTML') return <div ref={detailRef}>{message}</div>;
  else return message;
}

IntlMessage.propTypes = {
  type: PropTypes.string,
  onclick: PropTypes.func,
};
export default IntlMessage;
